import { useIsMobile } from "@/hooks/use-mobile";
import { SearchContent } from "./SearchContent";
import {
  Sheet,
  SheetContent,
} from "@/components/ui/sheet";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";

interface SearchModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SearchModal({ open, onOpenChange }: SearchModalProps) {
  const isMobile = useIsMobile();

  const handleClose = () => {
    onOpenChange(false);
  };

  // Mobile: Sheet from bottom
  if (isMobile) {
    return (
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent side="bottom" className="p-0 h-auto max-h-[80vh]">
          <SearchContent onClose={handleClose} />
        </SheetContent>
      </Sheet>
    );
  }

  // Desktop: Dialog (centered modal)
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[550px] max-w-[90vw] p-0 gap-0 bg-card border border-border shadow-xl">
        <SearchContent onClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
}
